import { render, staticRenderFns } from "./ExcelTransporters.vue?vue&type=template&id=197de60b&scoped=true&"
import script from "./ExcelTransporters.vue?vue&type=script&lang=js&"
export * from "./ExcelTransporters.vue?vue&type=script&lang=js&"
import style0 from "./ExcelTransporters.vue?vue&type=style&index=0&id=197de60b&scoped=true&lang=css&"
import style1 from "./ExcelTransporters.vue?vue&type=style&index=1&lang=css&"
import style2 from "../../../node_modules/handsontable/dist/handsontable.full.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197de60b",
  null
  
)

export default component.exports